"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSettings = void 0;
exports.defaultSettings = {
    devMode: false,
    preserveDataOnDisqualification: false,
};
